import { portalDs } from 'src/components/portal-design-system';
import { cn } from 'src/lib/utils';

export interface FilterBarSelectOption {
  value: string;
  label: string;
}

export interface FilterBarSelect {
  id: string;
  label: string;
  value: string;
  options: FilterBarSelectOption[];
  onChange: (value: string) => void;
}

export interface FilterBarProps {
  searchValue: string;
  searchPlaceholder?: string;
  onSearchChange: (value: string) => void;
  selects?: FilterBarSelect[];
  className?: string;
}

export function FilterBar({
  searchValue,
  searchPlaceholder = 'Search…',
  onSearchChange,
  selects = [],
  className,
}: FilterBarProps) {
  return (
    <div
      className={cn(
        'flex flex-col gap-3 rounded-xl border border-[#EDEEF2] bg-white p-4 sm:flex-row sm:flex-wrap sm:items-end',
        className,
      )}
    >
      <label className={cn(portalDs.field, 'min-w-[220px] flex-1')}>
        <span className={portalDs.filterLabel}>Search</span>
        <input
          type="search"
          className={portalDs.input}
          placeholder={searchPlaceholder}
          value={searchValue}
          onChange={(event) => onSearchChange(event.target.value)}
        />
      </label>

      {selects.map((select) => (
        <label key={select.id} className={cn(portalDs.field, 'min-w-[160px]')}>
          <span className={portalDs.filterLabel}>{select.label}</span>
          <select
            className={portalDs.select}
            value={select.value}
            onChange={(event) => select.onChange(event.target.value)}
          >
            {select.options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
      ))}
    </div>
  );
}
